export enum ImageType {
  MAIN = 'main',
  FRONT = 'front',
  REAR = 'rear',
  INTERIOR = 'interior',
  EXTERIOR_360 = 'exterior360',
  INTERIOR_360_PANORAMIC = 'interior360panoramic',
}
